import { render } from "./NavigationMenu.vue?vue&type=template&id=2f35614b&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=2f35614b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f35614b"]])

export default __exports__